export default __webpack_public_path__ + "media/sad.e38adcc7.svg";